<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSystemTaskDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['configurationManagement:systemTask:delete']"
            @click="systemTaskDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除定时任务模式框 -->
    <Modal v-model="systemTaskDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ beanNames }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeSystemTask()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑定时任务模式框 -->
    <Modal
      v-model="systemTaskEditmodal"
      title="编辑定时任务"
      :loading="loading"
      @on-ok="systemTaskEditSubmit('systemTaskEditForm')"
      @on-cancel="systemTaskEditReset('systemTaskEditForm')"
      :mask-closable="false"
    >
      <Form
        ref="systemTaskEditForm"
        :model="systemTaskEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- bean名称 -->
        <FormItem label="bean名称" prop="beanName">
          <Input v-model="systemTaskEditForm.beanName" style="width:260px;" />
        </FormItem>

        <!-- 方法名称 -->
        <FormItem label="方法名称" prop="methodName">
          <Input v-model="systemTaskEditForm.methodName" style="width:260px;" />
        </FormItem>

        <!-- 方法参数 -->
        <FormItem label="方法参数" prop="methodParams">
          <Input
            v-model="systemTaskEditForm.methodParams"
            style="width:260px;"
          />
        </FormItem>

        <!-- cron表达式 -->
        <FormItem label="cron表达式" prop="cronValue">
          <input-cron
            type="text"
            v-model="systemTaskEditForm.cronValue"
            style="width:315px;"
          />
        </FormItem>

        <!-- 状态 -->
        <FormItem label="状态" prop="state">
          <RadioGroup v-model="systemTaskEditForm.state">
            <Radio
              v-for="list in stateList"
              :label="list.state"
              :key="list.value"
              >{{ list.label }}</Radio
            >
          </RadioGroup>
        </FormItem>

        <!-- 备注 -->
        <FormItem label="备注" prop="remark">
          <Input
            v-model="systemTaskEditForm.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import InputCron from "../../../easy_cron/input-cron";
import CronValidator from "../../../easy_cron/validator";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
var tableSystemTaskVue = {};
export default {
  name: "TableSystemTask",
  components: {
    InputCron
  },
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      systemTaskDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      beanNames: "",
      systemTaskEditmodal: false, //编辑
      loading: true,
      systemTaskEditForm: {
        beanName: "",
        methodName: "",
        methodParams: "",
        cronValue: "",
        state: "",
        remark: ""
      },
      stateList: [
        {
          label: "正常",
          value: "normal",
          state: "1"
        },
        {
          label: "暂停",
          value: "suspend",
          state: "0"
        }
      ],
      ruleValidate: {
        beanName: [
          { required: true, message: "请输入bean名称", trigger: "blur" },
          {
            message: "bean名称为1-20个字符、不包含特殊字符",
            pattern: "^[A-Za-z0-9]{1,20}$",
            trigger: "blur"
          }
        ],
        methodName: [
          { required: true, message: "请输入方法名称", trigger: "blur" },
          {
            message: "方法名称为1-20个字符、不包含特殊字符",
            pattern: "^[A-Za-z0-9]{1,20}$",
            trigger: "blur"
          }
        ],
        methodParams: [
          { required: false, message: "请输入方法参数", trigger: "blur" }
        ],
        cronValue: [{ validator: CronValidator }],
        // cronValue: [
        //     { required: true, message: '请输入cron表达式', trigger: 'blur' }
        // ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
        remark: [
          { required: false, message: "请输入备注", trigger: "blur" },
          {
            type: "string",
            max: 100,
            message: "最多输入100个字符",
            trigger: "blur"
          }
        ]
      },
      columns: [
        {
          title: this.$t("configuration_management.system_task.taskID"),
          key: "id"
        },
        {
          title: this.$t("configuration_management.system_task.beanName"),
          key: "beanName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.systemTaskEditmodal = true; //编辑定时任务弹出层
                    this.systemTaskEditForm.id = params.row.id;
                    // bean名称
                    this.systemTaskEditForm.beanName = params.row.beanName;
                    // 方法名称
                    this.systemTaskEditForm.methodName = params.row.methodName;
                    // 方法参数
                    this.systemTaskEditForm.methodParams =
                      params.row.methodParams;
                    // cron表达式
                    this.systemTaskEditForm.cronValue =
                      params.row.cronExpression;
                    // 状态
                    /*********************************************************/
                    // 正常
                    if (params.row.state == 1) {
                      this.systemTaskEditForm.state = "1";
                    }
                    // 暂停
                    else if (params.row.state == 0) {
                      this.systemTaskEditForm.state = "0";
                    }

                    // 备注
                    this.systemTaskEditForm.remark = params.row.remark;
                  }
                }
              },
              params.row.beanName
            );
          }
        },
        {
          title: this.$t("configuration_management.system_task.methodName"),
          key: "methodName"
        },
        {
          title: this.$t(
            "configuration_management.system_task.methodParameter"
          ),
          key: "methodParams"
        },
        {
          title: this.$t(
            "configuration_management.system_task.cronExpressioin"
          ),
          key: "cronExpression"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "state",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  // 数据库0暂停,1正常
                  props: {
                    type: "primary",
                    size: "large",
                    value: params.row.state == "1" // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": () => {
                      this.switch(params.index);
                    }
                  }
                },
                [
                  h("span", {
                    slot: "open",
                    domProps: {
                      innerHTML: this.$t(
                        "configuration_management.system_task.ok"
                      )
                    }
                  }),
                  h("span", {
                    slot: "close",
                    domProps: {
                      innerHTML: this.$t(
                        "configuration_management.system_task.paused"
                      )
                    }
                  })
                ]
              )
            ]);
          }
        },
        {
          title: this.$t("configuration_management.system_task.note"),
          key: "remark"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableSystemTaskDate: []
    };
  },
  beforeCreate: function() {
    tableSystemTaskVue = this;
  },
  mounted: function() {
    tableSystemTaskVue.getSystemTaskData();
  },
  methods: {
    showAll: function() {
      tableSystemTaskVue.getSystemTaskData();
    },
    // 分页显示数据
    /****************************************************/
    getSystemTaskData: function() {
      // 获取SystemTaskSearch里面的搜索内容
      eventBus.$on("systemTaskSearchName", function(val) {
        tableSystemTaskVue.val = val;
      });
      //定时任务列表分页
      this.$api.systemTask
        .pageSystemTask({
          beanName: tableSystemTaskVue.val,
          pageNum: this.current,
          pageSize: this.pageSize,
          createdBy: getCookie(global.cookieName)
        })
        .then(res => {
          this.tableSystemTaskDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSystemTaskVue.getSystemTaskData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSystemTaskVue.getSystemTaskData();
    },
    // 销毁systemTaskSearchName
    beforeDestroy: function() {
      eventBus.$off("systemTaskSearchName");
    },
    // switch
    /****************************************************/
    switch(index) {
      this.index = index;
      // 打开是true,0暂停 1正常
      if (this.tableSystemTaskDate[index].state == 0) {
        this.changeStatusMessage(
          this.tableSystemTaskDate[index].id,
          "state",
          1
        );
      } else {
        this.changeStatusMessage(
          this.tableSystemTaskDate[index].id,
          "state",
          0
        );
      }
    },
    // 更新反馈信息某一字段
    changeStatusMessage: function(id, key, value) {
      // 编辑状态
      this.$api.systemTask
        .changeStatus({
          id: id,
          state: value
        })
        .then(res => {
          tableSystemTaskVue.getSystemTaskData();
        });
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.beanNames = this.tableSystemTaskDate[index].beanName;
    },
    removeSystemTask: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.systemTask
        .deleteSystemTask("id", this.tableSystemTaskDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableSystemTaskVue.getSystemTaskData();
            this.isDisable = false;
            this.modal_loading = false;
            this.systemTaskDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 编辑定时任务
    /****************************************************/
    systemTaskEditSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 编辑定时任务
          this.$api.systemTask
            .updateSystemTask({
              id: this.systemTaskEditForm.id,
              beanName: this.systemTaskEditForm.beanName,
              methodName: this.systemTaskEditForm.methodName,
              methodParams: this.systemTaskEditForm.methodParams,
              cronExpression: this.systemTaskEditForm.cronValue,
              state: this.systemTaskEditForm.state,
              remark: this.systemTaskEditForm.remark,
              createdBy: getCookie(global.cookieName),
              modifiedBy: getCookie(global.cookieName)
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                tableSystemTaskVue.getSystemTaskData();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success("编辑成功");
                this.systemTaskEditmodal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("编辑失败");
        }
      });
    },
    systemTaskEditReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/system_task/TableSystemTask.vue